import axios from "axios";

export const errorResponse = (message: string, error: unknown): string => {
  let errorMessage = message;

  if (axios.isAxiosError(error)) {
    if ((error as any)?.response?.data.message) {
      errorMessage = (error as any).response.data.message;
    } else if ((error as Error).message) {
      errorMessage = (error as Error).message;
    }
  } else if (error instanceof Error) {
    errorMessage = error.message;
  }

  return errorMessage;
};
